import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_ID_NEXT_PATH_KEY } from '@/swagger/constants/quiz-keys';
import { API_POST_QUIZ_BY_ID_NEXT, KEY_POST_QUIZ_BY_ID_NEXT } from '../constats';
import { MOCK_RESPONSE_POST_QUIZ_BY_ID_NEXT } from '../mocks';

type PostQuizByIdNext = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_ID_NEXT_PATH_KEY
>;

type RequestPostQuizByIdNext = PostQuizByIdNext['request']['body'] &
  PostQuizByIdNext['request']['path'];

type ResponsePostQuizByIdNext = PostQuizByIdNext['response']['body'];

type CallParamsPostQuizByIdNext = Omit<RequestPostQuizByIdNext, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePostQuizByIdNext = ResponsePostQuizByIdNext;

type CallErrorPostQuizByIdNext = GenericApiError;

type CallSelectorsPostQuizByIdNext = {
  activeStep: ResponsePostQuizByIdNext;
};

export const postQuizByIdNextCall = createGeneralCall<
  CallParamsPostQuizByIdNext,
  CallResponsePostQuizByIdNext,
  CallErrorPostQuizByIdNext,
  CallSelectorsPostQuizByIdNext
>({
  id: KEY_POST_QUIZ_BY_ID_NEXT,
  method: 'post',
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_POST_QUIZ_BY_ID_NEXT(org, payload.id);
    },
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_POST_QUIZ_BY_ID_NEXT
    : undefined,
  selectors: {
    activeStep: ({ selectors }) => createSelector(selectors.response, res => res || undefined),
  },
});
